<template>
    <rkm-row>
        <rkm-col cols="4">
            <rkm-form-select
                :options="data.form.situacaoRua"
                label="Tempo em situação de rua"
                show-default-option
                text-field="descricao"
                v-model="data.model.situacaoRua.situacaoRuaId"
                default-option-text="NÃO ESTÁ EM SITUAÇÃO DE RUA"
                value-field="id"
                :disabled="data.model.recusaCadastro"
            />
        </rkm-col>

        <rkm-col cols="3" v-if="handleSituacaoRua()">

            <rkm-form-radio-group
                v-model="data.model.situacaoRua.outraInstituicao"
                label="Acompanhado por outra instituição?"
                @change="resetOutraInstituicaoQuais()"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="5" v-if="handleSituacaoRua()">

            <rkm-form-input
                label="Quais"
                v-model="data.model.situacaoRua.outraInstituicaoQuais"
                :disabled="!data.model.situacaoRua.outraInstituicao"
                :validations="validations.outraInstituicao"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="2" v-if="handleSituacaoRua()">
            <rkm-form-radio-group
                v-model="data.model.situacaoRua.recebeBeneficio"
                label="Recebe algum benefício?"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2" v-if="handleSituacaoRua()">
            <rkm-form-radio-group
                v-model="data.model.situacaoRua.referenciaFamiliar"
                label="Possui referência familiar?"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="3" v-if="handleSituacaoRua()">
            <rkm-form-radio-group
                v-model="data.model.situacaoRua.visitaFamiliar"
                label="Visita algum familiar com frequência?"
                @change="resetParentesco()"

            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="5" v-if="handleSituacaoRua()">

            <rkm-form-input
                label="Parentesco"
                v-model="data.model.situacaoRua.parentesco"
                :disabled="!data.model.situacaoRua.visitaFamiliar"
                :validations="data.model.situacaoRua.visitaFamiliar == true ? validations.parentesco : {}"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="2" v-if="handleSituacaoRua()">
            <rkm-form-select
                :options="data.form.alimentacaoDiaria"
                label="Alimentação diária"
                show-default-option
                text-field="descricao"
                v-model="data.model.situacaoRua.alimentacaoDiariaId"
                default-option-text="Selecione"
                value-field="id"
                :validations="validations.alimentacaoDiaria"
            />
        </rkm-col>

        <rkm-col cols="10" v-if="handleSituacaoRua()">
            <rkm-form-checkbox-group
                :options="data.form.origemAlimentacao"
                label="Origem da alimentação"
                name="origemAlimentacao"
                text-field="descricao"
                v-model="data.model.situacaoRua.origemAlimentacao"
                value-field="id"
                :validations="validations.origemAlimentacao"
            />
        </rkm-col>

        <rkm-col cols="2" v-if="handleSituacaoRua()">
            <rkm-form-radio-group
                v-model="data.model.situacaoRua.higienePessoal"
                label="Acesso a higiene pessoal?"
                @change="resetHigienePessoal()"

            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="10" v-if="handleSituacaoRua()">
            <rkm-form-checkbox-group
                :options="data.form.higienePessoal"
                label="Quais"
                name="higienePessoal"
                text-field="descricao"
                v-model="data.model.situacaoRua.higienePessoalQuais"
                value-field="id"
                :disabled="!data.model.situacaoRua.higienePessoal"
                :validations="data.model.situacaoRua.higienePessoal == true ? validations.higienePessoal : {}"
            />
        </rkm-col>
    </rkm-row>
</template>

<script>

export default {
    computed: {
        validations() {

            return {
                outraInstituicao: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                },
                parentesco: {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                    required: this.data.model.situacaoRua.visitaFamiliar
                },
                higienePessoal: {
                    required: true,
                },
            }
        },
    },
    methods: {
        handleSituacaoRua() {

            if (this.data.model.situacaoRua.situacaoRuaId == null) {
                this.resetSituacaoRua()
            }

            return this.data.model.situacaoRua.situacaoRuaId !== null
        },
        resetOutraInstituicaoQuais() {

            if (!this.data.model.situacaoRua.outraInstituicao) {
                this.data.model.situacaoRua.outraInstituicaoQuais = null
            }
        },
        resetParentesco() {

            if (!this.data.model.situacaoRua.visitaFamiliar) {
                this.data.model.situacaoRua.parentesco = null
            }
        },
        resetHigienePessoal() {

            if (!this.data.model.situacaoRua.higienePessoal) {
                this.data.model.situacaoRua.higienePessoalQuais = []
            }
        },
        resetSituacaoRua(){

            this.data.model.situacaoRua.outraInstituicao = false
            this.data.model.situacaoRua.outraInstituicaoQuais = null
            this.data.model.situacaoRua.recebeBeneficio = false
            this.data.model.situacaoRua.referenciaFamiliar = false
            this.data.model.situacaoRua.visitaFamiliar = false
            this.data.model.situacaoRua.parentesco = null
            this.data.model.situacaoRua.alimentacaoDiariaId = null
            this.data.model.situacaoRua.origemAlimentacao = []
            this.data.model.situacaoRua.higienePessoal = false
            this.data.model.situacaoRua.higienePessoalQuais = []
        }
    },
    props: {
        data: { type: Object, required: false, },
    }
}
</script>